import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Nlayout from './Nlayout';
import './Rankings.css';
import { FaCrown, FaSearch, FaSyncAlt } from 'react-icons/fa';
import coinImg from './Wild_coin.png';

// Fallback avatar generator
const getAvatarUrl = (username) => {
    return `https://api.dicebear.com/7.x/identicon/svg?seed=${encodeURIComponent(username)}`;
};

export default function UltimoRanking({ isMobile }) {
    const [activeTab, setActiveTab] = useState('chat'); // 'chat' | 'top200'
    const [rankingData, setRankingData] = useState(null);
    const [usuarios, setUsuarios] = useState([]);
    const [primeros200, setPrimeros200] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [lastUpdated, setLastUpdated] = useState(null);
    const pollingIntervalRef = useRef(null);

    const obtenerUltimoRanking = async () => {
        try {
            const res = await axios.get(
                "https://backend.eldenguee.com/torneos/ranking/ultimo"
            );

            setRankingData(res.data);

            let ranking = res.data.ranking_json;
            if (typeof ranking === "string") {
                ranking = JSON.parse(ranking);
            }

            const lista = Object.entries(ranking || {})
                .map(([username, datos]) => ({
                    username,
                    mensajes: datos.mensajes,
                    esMod: datos.esMod,
                    profile: datos.profile_picture || null
                }))
                .sort((a, b) => b.mensajes - a.mensajes);

            setUsuarios(lista);

            // Parsear primeros200_json dinámicamente
            let p200 = res.data.primeros200_json || res.data.primeros200 || [];
            if (typeof p200 === "string") {
                try {
                    p200 = JSON.parse(p200);
                } catch (e) {
                    console.error("Error al parsear primeros200_json:", e);
                    p200 = [];
                }
            }
            setPrimeros200(Array.isArray(p200) ? p200 : []);

            setLastUpdated(
                new Date().toLocaleTimeString("es-ES", {
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit"
                })
            );
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        obtenerUltimoRanking();

        // Polling cada 5 minutos
        pollingIntervalRef.current = setInterval(
            obtenerUltimoRanking,
            5 * 60 * 1000 // 300000 ms
        );

        return () => {
            if (pollingIntervalRef.current) {
                clearInterval(pollingIntervalRef.current);
            }
        };
    }, []);

    // podium data
    const firstPlace = usuarios.length > 0 ? usuarios[0] : null;
    const secondPlace = usuarios.length > 1 ? usuarios[1] : null;
    const thirdPlace = usuarios.length > 2 ? usuarios[2] : null;

    // Remaining users: Show top 50 (ranks 4 to 50) when not searching.
    // If searching, search the entire user list (ranks 4+) and show matches with their real rank.
    const tableUsers = usuarios.filter((user, index) => {
        // Exclude podium (first 3 places) as they are shown separately
        if (index < 3) return false;

        if (searchTerm) {
            // Search globally across all remaining users
            return user.username.toLowerCase().includes(searchTerm.toLowerCase());
        }

        // Default view: only show up to top 100 (index 99 is the 100th user)
        return index < 100;
    });

    const formatRankingDate = () => {
        console.log(rankingData)
        if (!rankingData) return '';
        const fechaRaw = rankingData.ended_at;
        if (!fechaRaw) return 'Directo Activo';
        try {
            const date = new Date(fechaRaw);
            if (isNaN(date.getTime())) return 'Directo Activo';
            return `Stream del ${date.toLocaleDateString('es-ES', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            })}`;
        } catch (e) {
            return 'Directo Activo';
        }
    };

    return (
        <Nlayout>
            <div className="rankings-container">
                <div className="rankings-content">
                    <div className="rankings-header">
                        <h1 className="rankings-title">Rankings</h1>

                        {/* Tab Switcher */}
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', margin: '20px 0' }}>
                            <button
                                onClick={() => setActiveTab('chat')}
                                style={{
                                    padding: '10px 24px',
                                    borderRadius: '999px',
                                    fontWeight: 'bold',
                                    border: 'none',
                                    cursor: 'pointer',
                                    fontSize: '0.95rem',
                                    transition: 'all 0.3s ease',
                                    backgroundColor: activeTab === 'chat' ? '#3b82f6' : 'rgba(255,255,255,0.06)',
                                    color: activeTab === 'chat' ? '#fff' : '#94a3b8',
                                    boxShadow: activeTab === 'chat' ? '0 4px 14px rgba(59, 130, 246, 0.4)' : 'none'
                                }}
                            >
                                💬 Ranking de Chat
                            </button>
                            <button
                                onClick={() => setActiveTab('top200')}
                                style={{
                                    padding: '10px 24px',
                                    borderRadius: '999px',
                                    fontWeight: 'bold',
                                    border: 'none',
                                    cursor: 'pointer',
                                    fontSize: '0.95rem',
                                    transition: 'all 0.3s ease',
                                    backgroundColor: activeTab === 'top200' ? '#10b981' : 'rgba(255,255,255,0.06)',
                                    color: activeTab === 'top200' ? '#fff' : '#94a3b8',
                                    boxShadow: activeTab === 'top200' ? '0 4px 14px rgba(16, 185, 129, 0.4)' : 'none'
                                }}
                            >
                                🏆 Primeros 200
                            </button>
                        </div>


                        <>
                            <p className="rankings-subtitle">
                                {formatRankingDate()}
                            </p>
                            {lastUpdated && (
                                <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.85rem', marginTop: '-10px' }}>
                                    Actualizado por última vez a las {lastUpdated}
                                </p>
                            )}
                        </>

                    </div>

                    {activeTab === 'chat' ? (
                        <>
                            {/* Rules Card */}
                            <div className="rankings-rules-card">
                                <div className="rankings-rules-title">
                                    🏆 Reglas e Incentivos del Ranking
                                </div>
                                <div className="rankings-rules-grid">
                                    <div className="rankings-rule-item special">
                                        <span style={{ fontSize: '1.5rem', marginRight: '5px' }}>🎟️</span>
                                        <div>
                                            <p className="rankings-rule-text"><strong>Top 1 al 10</strong></p>
                                            <p className="rankings-rule-text" style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)' }}>
                                                Los primeros 10 puestos se llevan una Solicitud de Tipeo en 1xbet.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="rankings-rule-item">
                                        <span style={{ fontSize: '1.5rem', marginRight: '5px' }}>💰</span>
                                        <div>
                                            <p className="rankings-rule-text"><strong>Top 11 al 20</strong></p>
                                            <p className="rankings-rule-text" style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)' }}>
                                                Se llevan 1500 D-COINS que pueden ser canjeadas directamente en el Shop de la página.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="rankings-rule-item">
                                        <span style={{ fontSize: '1.5rem', marginRight: '5px' }}>💰</span>
                                        <div>
                                            <p className="rankings-rule-text"><strong>Top 21 al 30</strong></p>
                                            <p className="rankings-rule-text" style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)' }}>
                                                Se llevan 1250 D-COINS que pueden ser canjeadas directamente en el Shop de la página.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="rankings-rule-item">
                                        <span style={{ fontSize: '1.5rem', marginRight: '5px' }}>💰</span>
                                        <div>
                                            <p className="rankings-rule-text"><strong>Top 31 al 40</strong></p>
                                            <p className="rankings-rule-text" style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)' }}>
                                                Se llevan 1000 D-COINS que pueden ser canjeadas directamente en el Shop de la página.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="rankings-rule-item">
                                        <span style={{ fontSize: '1.5rem', marginRight: '5px' }}>💰</span>
                                        <div>
                                            <p className="rankings-rule-text"><strong>Top 41 al 70</strong></p>
                                            <p className="rankings-rule-text" style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)' }}>
                                                Se llevan 500 D-COINS que pueden ser canjeadas directamente en el Shop de la página.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="rankings-rule-item">
                                        <span style={{ fontSize: '1.5rem', marginRight: '5px' }}>💰</span>
                                        <div>
                                            <p className="rankings-rule-text"><strong>Top 71 al 90</strong></p>
                                            <p className="rankings-rule-text" style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)' }}>
                                                Se llevan 250 D-COINS que pueden ser canjeadas directamente en el Shop de la página.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="rankings-rule-item">
                                        <span style={{ fontSize: '1.5rem', marginRight: '5px' }}>💰</span>
                                        <div>
                                            <p className="rankings-rule-text"><strong>Top 91 al 100</strong></p>
                                            <p className="rankings-rule-text" style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)' }}>
                                                Se llevan 100 D-COINS que pueden ser canjeadas directamente en el Shop de la página.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {loading ? (
                                <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
                                    <div className="loader-spinner" style={{
                                        width: '45px',
                                        height: '45px',
                                        border: '4px solid rgba(255, 255, 255, 0.1)',
                                        borderTop: '4px solid #00ff73',
                                        borderRadius: '50%',
                                        animation: 'spin 1s linear infinite'
                                    }} />
                                </div>
                            ) : usuarios.length === 0 ? (
                                <div className="rankings-rules-card" style={{ textAlign: 'center', padding: '50px 20px' }}>
                                    <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '1.2rem', margin: 0 }}>
                                        El ranking está activo pero aún no hay mensajes registrados en este directo.
                                    </p>
                                </div>
                            ) : (
                                <>
                                    {/* Podium (Top 3) */}
                                    <div className="podium-container">
                                        {/* 2nd Place */}
                                        {secondPlace && (
                                            <div className="podium-card rank-2">
                                                <div className="podium-avatar-wrapper">
                                                    <img
                                                        src={secondPlace.profile || getAvatarUrl(secondPlace.username)}
                                                        alt={secondPlace.username}
                                                        className="podium-avatar"
                                                    />
                                                    <span className="podium-badge">2</span>
                                                </div>
                                                <div className="podium-username">{secondPlace.username}</div>
                                                <div className="podium-messages">
                                                    Mensajes: <span className="podium-messages-count">{secondPlace.mensajes}</span>
                                                </div>
                                                <div className="podium-reward">
                                                    🎟️ Tipeo 1xBet
                                                </div>
                                            </div>
                                        )}

                                        {/* 1st Place */}
                                        {firstPlace && (
                                            <div className="podium-card rank-1">
                                                <FaCrown className="podium-crown" style={{ color: '#fdb813' }} />
                                                <div className="podium-avatar-wrapper">
                                                    <img
                                                        src={firstPlace.profile || getAvatarUrl(firstPlace.username)}
                                                        alt={firstPlace.username}
                                                        className="podium-avatar"
                                                    />
                                                    <span className="podium-badge">1</span>
                                                </div>
                                                <div className="podium-username">{firstPlace.username}</div>
                                                <div className="podium-messages">
                                                    Mensajes: <span className="podium-messages-count">{firstPlace.mensajes}</span>
                                                </div>
                                                <div className="podium-reward" style={{ borderColor: 'rgba(253, 184, 19, 0.4)', color: '#fdb813' }}>
                                                    🎟️ Tipeo 1xBet
                                                </div>
                                            </div>
                                        )}

                                        {/* 3rd Place */}
                                        {thirdPlace && (
                                            <div className="podium-card rank-3">
                                                <div className="podium-avatar-wrapper">
                                                    <img
                                                        src={thirdPlace.profile || getAvatarUrl(thirdPlace.username)}
                                                        alt={thirdPlace.username}
                                                        className="podium-avatar"
                                                    />
                                                    <span className="podium-badge">3</span>
                                                </div>
                                                <div className="podium-username">{thirdPlace.username}</div>
                                                <div className="podium-messages">
                                                    Mensajes: <span className="podium-messages-count">{thirdPlace.mensajes}</span>
                                                </div>
                                                <div className="podium-reward" style={{ borderColor: 'rgba(205, 127, 50, 0.4)', color: '#cd7f32' }}>
                                                    🎟️ Tipeo 1xBet
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* Search & Action Bar */}
                                    <div className="rankings-controls">
                                        <div style={{ position: 'relative', flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                                            <input
                                                type="text"
                                                className="rankings-search-input"
                                                placeholder="Buscar tu nombre de usuario..."
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                style={{ paddingLeft: '45px' }}
                                            />
                                            <FaSearch style={{ position: 'absolute', left: '18px', color: 'rgba(255,255,255,0.3)' }} />
                                        </div>
                                        <button className="rankings-refresh-btn" onClick={obtenerUltimoRanking}>
                                            <FaSyncAlt style={{ marginRight: '6px' }} /> Actualizar
                                        </button>
                                    </div>

                                    {/* Remaining Users Table */}
                                    {tableUsers.length > 0 ? (
                                        <div className="rankings-table-container">
                                            <table className="rankings-table">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '60px' }}>Puesto</th>
                                                        <th>Usuario</th>
                                                        <th>Mensajes</th>
                                                        <th style={{ textAlign: 'right' }}>Recompensa</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {tableUsers.map((user) => {
                                                        const originalIndex = usuarios.findIndex(u => u.username === user.username);
                                                        const rank = originalIndex + 1;

                                                        let premio = null;

                                                        if (rank >= 1 && rank <= 10) {
                                                            premio = {
                                                                texto: "Tipeo 1xBet",
                                                                tipo: "bono"
                                                            };
                                                        } else if (rank >= 11 && rank <= 20) {
                                                            premio = {
                                                                texto: "1500 D-Coins",
                                                                tipo: "coins"
                                                            };
                                                        } else if (rank >= 21 && rank <= 30) {
                                                            premio = {
                                                                texto: "1250 D-Coins",
                                                                tipo: "coins"
                                                            };
                                                        } else if (rank >= 31 && rank <= 40) {
                                                            premio = {
                                                                texto: "1000 D-Coins",
                                                                tipo: "coins"
                                                            };
                                                        } else if (rank >= 41 && rank <= 70) {
                                                            premio = {
                                                                texto: "500 D-Coins",
                                                                tipo: "coins"
                                                            };
                                                        } else if (rank >= 71 && rank <= 90) {
                                                            premio = {
                                                                texto: "250 D-Coins",
                                                                tipo: "coins"
                                                            };
                                                        } else if (rank >= 91 && rank <= 100) {
                                                            premio = {
                                                                texto: "100 D-Coins",
                                                                tipo: "coins"
                                                            };
                                                        }

                                                        return (
                                                            <tr key={user.username}>
                                                                <td className={`cell-rank ${premio ? 'in-reward' : ''}`}>
                                                                    #{rank}
                                                                </td>

                                                                <td>
                                                                    <div className="cell-user">
                                                                        <img
                                                                            src={user.profile || getAvatarUrl(user.username)}
                                                                            alt={user.username}
                                                                            className="cell-user-avatar"
                                                                        />
                                                                        <span className="cell-username">{user.username}</span>
                                                                    </div>
                                                                </td>

                                                                <td className="cell-messages">
                                                                    <span className="cell-messages-count">{user.mensajes}</span>
                                                                    <span className="cell-messages-label"> Mensajes</span>
                                                                </td>

                                                                <td style={{ textAlign: 'right' }}>
                                                                    <span className={`cell-reward-badge ${premio ? premio.tipo : 'none'}`}>
                                                                        {premio ? (
                                                                            premio.tipo === "bono" ? (
                                                                                <>🎟️ {premio.texto}</>
                                                                            ) : (
                                                                                <>
                                                                                    <img
                                                                                        src={coinImg}
                                                                                        style={{ width: 14, height: 14 }}
                                                                                        alt="Coin"
                                                                                    />
                                                                                    <span>{premio.texto}</span>
                                                                                </>
                                                                            )
                                                                        ) : (
                                                                            "Sin premio"
                                                                        )}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : searchTerm && (
                                        <div className="rankings-rules-card" style={{ textAlign: 'center', padding: '30px 20px' }}>
                                            <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '1.1rem', margin: 0 }}>
                                                No se encontraron resultados para "{searchTerm}".
                                            </p>
                                        </div>
                                    )}
                                </>
                            )}
                        </>
                    ) : (
                        /* TAB PRIMEROS 200 */
                        <div className="rankings-table-container">
                            <table className="rankings-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: '80px' }}>Posición</th>
                                        <th>Usuario</th>
                                        <th style={{ textAlign: 'right' }}>Premio</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {primeros200.length > 0 ? (
                                        primeros200.map((item, index) => {
                                            const pos = item.posicion || index + 1;
                                            const uname = item.username || item.nombre || 'Usuario';
                                            let premio = null;

                                            if (pos >= 1 && pos <= 10) {
                                                premio = { texto: '1000 D-Coins', tipo: 'coins' };
                                            } else if (pos >= 11 && pos <= 50) {
                                                premio = { texto: '500 D-Coins', tipo: 'coins' };
                                            } else if (pos >= 51 && pos <= 100) {
                                                premio = { texto: '250 D-Coins', tipo: 'coins' };
                                            } else if (pos >= 101 && pos <= 200) {
                                                premio = { texto: '100 D-Coins', tipo: 'coins' };
                                            }
                                            return (
                                                <tr key={pos + '-' + uname}>
                                                    <td className={`cell-rank ${premio ? 'in-reward' : ''}`}>
                                                        #{pos}
                                                    </td>
                                                    <td>
                                                        <div className="cell-user">
                                                            <img
                                                                src={getAvatarUrl(uname)}
                                                                alt={uname}
                                                                className="cell-user-avatar"
                                                            />
                                                            <span className="cell-username" style={{ fontWeight: pos <= 3 ? 'bold' : 'normal' }}>
                                                                {uname}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <span className={`cell-reward-badge ${premio ? premio.tipo : 'none'}`}>
                                                            {premio ? (
                                                                premio.tipo === "bono" ? (
                                                                    <>🎟️ {premio.texto}</>
                                                                ) : (
                                                                    <>
                                                                        <img
                                                                            src={coinImg}
                                                                            style={{ width: 14, height: 14 }}
                                                                            alt="Coin"
                                                                        />
                                                                        <span>{premio.texto}</span>
                                                                    </>
                                                                )
                                                            ) : (
                                                                "Sin premio"
                                                            )}
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="3" style={{ textAlign: 'center', color: '#94a3b8', padding: '30px' }}>
                                                No hay registros disponibles en Primeros 200.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </Nlayout>
    );
}
